module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABZElEQVQ4jY3SP0iVURgG8N93u2WSiYLdQVDEMYdoCSRIJ9GgRYigzZYImlyCBKcIWpOmFkW3Chpzc3Y/S2BwRRpcpOifXfU2fO93/aR71QcOz/ud7zzPef+cLKWkhCk8wWPs+h+vUMNcsZGllGZxF+9wDasYxH1MIkMTj7COW+jFMraq+BBm6/ge8S+MYBxHsXcBP2JVcBuzWUqpiad4g1HcxCf8bFPCJL7ic3xvViLoDf4SGbUTwwbuYCYyulQYZMEDGMZQ8JXYf4E+vMRbbEdfVOPAfvAaJnAYdS7hGW5gL86MoB6XtQwuB093SP0eHuB9mLeyLgwawfMYw0Gk2B3mDXnjXqMfz+XNbBk0g/tw1fHoin9VXI9bj0q6VtAVvNihhHY40YM/wSvyEf3uILoof2Qz2CobFLwgH9lZqKOnLPwWvHMOcYG/aBRPWaRUOUVQRlM+ncEqHsaqOZ7GeXCIj/8Az8lPy2/MZNsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-baoming.png
// module id = veIT
// module chunks = 22